import {
    useEffect,
    useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  CART_INITIAL_STATE
} from "../../constants/constant";
import { getFCMServiceWorkerRegistration, listenForForegroundMessages, requestFCMToken } from "../../firebase";
import { getBaseNotificationCount, setBaseFcmNotification } from "../dashboard/dashboardNetworkController";

const SnpFcmNotification = ({
    setCount,
    setFcmNotification,
    showTrayNotifications,
}) => {

    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
    const navigate = useNavigate();
    const [serviceWorkerRegistration, setServiceWorkerRegistration] = useState(null);

    // --------------------------------------------
    // 🔵 1. REGISTER SERVICE WORKER (ONLY ONCE)
    // --------------------------------------------
    useEffect(() => {
        if ("serviceWorker" in navigator) {
            getFCMServiceWorkerRegistration()
                .then(async (registration) => {
                    setServiceWorkerRegistration(registration);
                    console.log("SW registered:", registration);
                })
                .catch((err) => console.error("SW registration failed:", err));
        }
    }, []);

    // --------------------------------------------
    // 🔵 2. SERVICE WORKER MESSAGE LISTENER (ONLY ONCE)
    // --------------------------------------------
    useEffect(() => {
        if (!("serviceWorker" in navigator)) return;

        const handler = (event) => {
            console.log("SW message:", event.data);

                // Update notification count
            getBaseNotificationCount(
                storeApiUrl.BACKEND_BASE_URL,
                storeActiveShopHash,
                (count) => setCount(count)
            );

                // Play sound
            if (event.data?.type === "play-sound") {
                const sound = localStorage.getItem("notificationSound") || "order_received_grab.mp3";
                setFcmNotification({ show: true, audioSrc: `/${sound}` });
            }

                // Navigation
            if (event.data?.type === "navigate") navigate(event.data.url);
        };

        navigator.serviceWorker.addEventListener("message", handler);

        return () => navigator.serviceWorker.removeEventListener("message", handler);
    }, [navigate, setCount, setFcmNotification, storeActiveShopHash, storeApiUrl]);

    // --------------------------------------------
    // 🔵 3. FCM TOKEN + FOREGROUND LISTENER
    // --------------------------------------------
    useEffect(() => {
        if (!CART_INITIAL_STATE.fcmNotification || !serviceWorkerRegistration) return;

        let disposed = false;
        let unsubscribe;

        (async () => {
            const token = await requestFCMToken(serviceWorkerRegistration);
            if (!token || disposed) return;

            setBaseFcmNotification(
                CART_INITIAL_STATE.apiToken,
                storeApiUrl.BACKEND_BASE_URL,
                storeActiveShopHash,
                token,
                null
            );

            unsubscribe = await listenForForegroundMessages((payload) => {
                console.log("Foreground FCM:", payload);

                const title = payload.notification?.title || payload.data?.title;
                const body = payload.notification?.body || payload.data?.body;
                const url = payload.data?.url || "/";

                if (document.visibilityState === "visible") {
                    // App is open → show sound + popup
                    const sound = localStorage.getItem("notificationSound") || "order_received_grab.mp3";
                    setFcmNotification({
                        show: true,
                        audioSrc: `/${sound}`,
                    });

                    getBaseNotificationCount(
                        storeApiUrl.BACKEND_BASE_URL,
                        storeActiveShopHash,
                        (count) => setCount(count)
                    );
                } else {
                    // Background → show system tray notification
                    showTrayNotifications(title, body, url);
                }
            });

        })();

        return () => {
            disposed = true;
            if (unsubscribe) unsubscribe();
        };
    }, [serviceWorkerRegistration, showTrayNotifications, storeApiUrl, storeActiveShopHash, setCount, setFcmNotification]);

    return null;
};

export default SnpFcmNotification;
